var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nodata-row"},[_c('div',{staticClass:"nodata-wraper"},[_c('img',{staticClass:"nodata",attrs:{"draggable":"false","src":require("@/assets/empty.png")}}),_c('span',{staticClass:"nodata nodata-txt"},[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }